export default function Benefits() {
  return (
    <div className="px-10 py-20 bg-gray-50 text-center">
      <h2 className="text-3xl font-bold mb-4">
        Why Choose Our Smart Booking System?
      </h2>

      <p className="text-gray-600 max-w-3xl mx-auto">
        Our AI-powered platform ensures instant service booking,
        intelligent helper matching and seamless automation.
      </p>

      <div className="grid md:grid-cols-3 gap-8 mt-12">
        <div className="bg-white p-6 rounded-xl shadow-md text-left hover:shadow-lg transition">
          <h3 className="font-semibold text-xl mb-2">
            Instant AI Chat Booking
          </h3>
          <p className="text-gray-600">
            Users can book services in Hindi or English using simple chat.
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-md text-left hover:shadow-lg transition">
          <h3 className="font-semibold text-xl mb-2">
            Smart Auto Assignment
          </h3>
          <p className="text-gray-600">
            Automatically assigns nearest available helper using location & skill matching.
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-md text-left hover:shadow-lg transition">
          <h3 className="font-semibold text-xl mb-2">
            15-Minute Service Promise
          </h3>
          <p className="text-gray-600">
            Real-time tracking and quick fulfillment guarantee.
          </p>
        </div>
      </div>
    </div>
  );
}
